import { RiQuestionFill } from 'react-icons/ri';
import { RoleNavbar } from 'src/layouts/dashboard/navbar/Navbar';
import { NavbarAdminMainButton } from 'src/layouts/dashboard/navbar/admin/NavbarAdminMainButton';
import { NavbarMemberMainButton } from 'src/layouts/dashboard/navbar/member/NavbarMemberMainButton';
import { PATH_HELP } from 'src/routes/paths';

interface Props {
  role: RoleNavbar;
}

export const HelpButton = ({ role }: Props) => {
  const handleClick = () => {
    window.open(PATH_HELP, '_blank', 'noopener,noreferrer');
  };

  if (role === 'member') {
    return (
      <NavbarMemberMainButton
        startIcon={<RiQuestionFill size={18} />}
        sx={{ width: '100%' }}
        onClick={handleClick}
      >
        ヘルプ
      </NavbarMemberMainButton>
    );
  } else {
    return (
      <NavbarAdminMainButton
        title="ヘルプ"
        startIcon={<RiQuestionFill size={18} />}
        sx={{
          width: '100%',
          padding: '5px 0px',
          '& .MuiButton-startIcon': {
            marginLeft: '12px',
            marginRight: '12px',
          },
        }}
        onClick={handleClick}
      />
    );
  }
};
